import type { GenderDetection } from '../types/genetic';

/** Y chromosome present = male; absent = female. X count is informational only. */
export const detectGender = ({
  hasYChromosome,
  xChromosomeCount,
}: {
  hasYChromosome: boolean;
  xChromosomeCount: number;
}): GenderDetection => ({
  gender: hasYChromosome ? 'male' : 'female',
  hasYChromosome,
  xChromosomeCount,
  confidence: 'high',
});
